export default __webpack_public_path__ + "static/user-img-3-ea87cc3d520384f011fea55c1668fdcf.png";